import React from 'react';
import { StyledButton } from '../styles/StyledButtons';
import { StyledInput } from '../styles/StyledInputs';
import StyledModal from '../styles/StyledModal';
import { Box } from '@mui/material';

interface CreateFundOpportunityModalProps {
  open: boolean;
  onClose: () => void;
  newOppName: string;
  setNewOppName: (value: string) => void;
  newOppSummaryTitle: string;
  setNewOppSummaryTitle: (value: string) => void;
  newOppNameError?: string;
  newOppSummaryTitleError?: string;
  onSubmit: () => void;
}

const CreateFundOpportunityModal: React.FC<CreateFundOpportunityModalProps> = ({
  open,
  onClose,
  newOppName,
  setNewOppName,
  newOppSummaryTitle,
  setNewOppSummaryTitle,
  newOppNameError,
  newOppSummaryTitleError,
  onSubmit,
}) => {
  return (
    <StyledModal
      fullWidth
      maxWidth="lg"
      open={open}
      onClose={onClose}
      title="Create new opportunity"
      tone="tone1"
      actions={
        <StyledButton
          variant="contained"
          onClick={onSubmit}
          disabled={
            !!newOppNameError || !newOppName || !!newOppSummaryTitleError || !newOppSummaryTitle
          }
        >
          Submit
        </StyledButton>
      }
    >
      <Box
        sx={{
          px: 3,
          pt: 2,
          pb: 3,
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
        }}
      >
        <StyledInput
          value={newOppName}
          label="Opportunity Name"
          onChange={(e) => setNewOppName(e.target.value)}
          onBlur={(e) => {
            if (newOppSummaryTitle.trim() === '') {
              setNewOppSummaryTitle(e.target.value);
            }
          }}
          autoFocus
          fullWidth
          error={!!newOppNameError}
          helperText={newOppNameError || ' '}
        />
        <StyledInput
          value={newOppSummaryTitle}
          label="Summary Title"
          onChange={(e) => setNewOppSummaryTitle(e.target.value)}
          fullWidth
          error={!!newOppSummaryTitleError}
          helperText={newOppSummaryTitleError || ' '}
        />
      </Box>
    </StyledModal>
  );
};

export default CreateFundOpportunityModal;
